module.exports = __webpack_public_path__ + "assets/img/kv-c7c174a5.jpg";